module.exports = __webpack_public_path__ + "img/739.2e7ffb3b.jpg";